import { Configuration, PopupRequest, BrowserCacheLocation } from "@azure/msal-browser";

// Configuração do Azure AD
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || ""}`,
        redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
        postLogoutRedirectUri: "http://localhost:3000",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: true,
    },
    system: {
        allowRedirectInIframe: true,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                // Logs removidos para manter o código limpo
            },
            logLevel: 2, // Info level
        }
    }
};

// Escopos necessários para a aplicação
export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "email", "profile", "openid"]
};

// Configuração para verificar se o usuário está autenticado
export const protectedResources = {
    api: {
        endpoint: process.env.REACT_APP_API_URL || "http://localhost:8000",
        scopes: ["User.Read"],
    },
}; 